export default {
	common: {
		viewMore: 'View More'
	},
	banner: {
		title: 'Investor Relations',
		aboutOSL: 'About OSL',
		subtitle: "Asia's Leading Stablecoin Trading and Payment Infrastructure",
		description:
			'OSL strives to provide compliant and efficient digital financial infrastructure services globally, empowering enterprises, financial institutions and individuals to seamlessly exchange, pay, trade, and settle between fiat currencies and digital assets'
	},
	nav: {
		home: 'Home',
		financials: 'Financials',
		filings: 'Filings',
		newsEvents: 'News & Events',
		corporateGovernance: 'Corporate Governance',
		investorTools: 'Investor Tools'
	},
	pages: {
		home: {
			title: 'Home',
			welcome: 'Welcome to Investor Relations Platform',
			description: 'Explore our financials, filings, news & events, corporate governance, and investor tools.',
			stockInformation: 'Stock Information',
			financials: 'Financials',
			news: 'News',
			events: 'Events',
			irContact: 'IR Contact',
			irContactSection: {
				investorContact: 'Investor Contact',
				investorContactDesc:
					'Questions for Investor Relations can be emailed to investor@coinbase.com or submitted by clicking the button below.',
				contactUs: 'Contact us',
				email: 'Email'
			}
		},
		financials: {
			title: 'Financials',
			interim: 'Interim',
			annual: 'Annual',
			announcements: 'Announcements',
			fullReport: 'Full Report',
			presentation: 'Presentation',
			webcast: 'Webcast',
			viewMore: 'View More'
		},
		filings: {
			title: 'HKEX Filings',
			year: 'Year',
			category: 'Category(Multiple Selection)',
			pleaseSelect: 'Please Select',
			keyword: 'Keyword',
			search: 'Search',
			reset: 'Reset',
			tableCategory: 'Category',
			description: 'Description',
			date: 'Date',
			view: 'View',
			totalResults: 'Total Results',
			itemsPerPage: 'Items Per Page',
			previous: 'Previous',
			next: 'Next'
		},
		newsEvents: {
			title: 'News & Events'
		},
		news: {
			title: 'News'
		},
		events: {
			title: 'Events'
		},
		corporateGovernance: {
			title: 'Corporate Governance',
			tabs: {
				seniorManagement: 'Senior Management',
				boardMembers: 'Board Members',
				corporateGovernanceFiles: 'Corporate Governance Files',
				committeesAndBoardRoles: 'Committees and Board Roles'
			},
			table: {
				date: 'Date',
				document: 'Document',
				download: 'Download'
			},
			committeesTable: {
				name: 'Name',
				auditCommittee: 'Audit Committee',
				nominationCommittee: 'Nomination Committee',
				remunerationCommittee: 'Remuneration Committee',
				riskManagementCommittee: 'Risk Management Committee',
				chairman: 'Chairperson',
				member: 'Member'
			},
			updateLatestFile: 'updated on: {date}'
		},
		investorTools: {
			title: 'Investor Tools',
			tabs: {
				analystCoverage: 'Analyst Coverage',
				investorFAQs: 'Investor FAQs',
				investorEmailAlerts: 'Investor Email Alerts',
				investorContacts: 'Investor Contacts'
			}
		},
		investorEmailAlerts: {
			title: 'Subscribe To Investor Email Alerts',
			unsubscribe: 'Unsubscribe From Investor Email Alerts',
			unsubscribeDescription:
				'To opt-out of investor email alerts, please enter your email address in the field below and you will be removed from all investor relations email alerts to which you are subscribed. After pressing "Send code", you will receive a confirmation email to the requested email address. You must click the confirmation link in order to complete your request to unsubscribe.',
			required: 'Required',
			privacyHint: 'For further information on how we protect your information, please refer to our {link}.',
			privacyPolicy: 'Privacy Policy',
			privacyHref: 'https://www.osl.com/hk-en/support/article/kA0fv00000001lhCAA',
			form: {
				email: 'Email Address',
				verification: 'Verification',
				sendCode: 'Send code',
				sendCodeCountdown: 'Send code({seconds}s)',
				events: 'Investor Alert Options',
				unsubscribe: 'Unsubscribe',
				submit: 'Submit'
			},
			placeholders: {
				email: 'Please enter your email address',
				verificationCode: 'Please enter verification code'
			},
			validation: {
				emailRequired: 'Please enter your email address',
				emailInvalid: 'Please enter a valid email address',
				verificationCodeRequired: 'Please enter verification code',
				subscribeRequired: 'Please select at least one subscription option'
			},
			submitSuccess: 'Subscription successful!',
			unsubscribeSuccess: 'Unsubscribe successful!',
			unsubscribeFailed: 'Unsubscription failed: No active subscription found',
			subscribeFailed: 'You are already subscribed.',
			sendCodeTooFrequent: 'Verification code sent too frequently. Please wait and try again.'
		},
		investorContacts: {
			form: {
				firstName: 'First Name',
				lastName: 'Last Name',
				email: 'Email',
				phone: 'Phone',
				question: 'Message',
				submit: 'Submit',
				reset: 'Reset'
			},
			placeholders: {
				firstName: 'Please enter your first name',
				lastName: 'Please enter your last name',
				email: 'Please enter your email',
				phone: 'Please enter your phone',
				question: 'Please enter your question or message',
				customField: 'Please enter {name}'
			},
			validation: {
				firstNameRequired: 'Please enter your first name',
				lastNameRequired: 'Please enter your last name',
				emailRequired: 'Please enter your email',
				emailInvalid: 'Please enter a valid email address',
				phoneRequired: 'Please enter your phone',
				questionRequired: 'Please enter your question or message',
				customFieldRequired: 'Please enter {name}'
			},
			submitSuccess: 'Successfully, thank you for your attention and suggestions!'
		},
		analystCoverage: {
			table: {
				company: 'Company',
				analysts: 'Analysts',
				email: 'Email'
			}
		},
		investorFAQs: {
			displayAll: 'Display All',
			hideAll: 'Hide All'
		},
		notFound: {
			message: 'Page Not Found',
			backBtn: 'Back to Home'
		}
	},
	language: {
		select: 'Select Language',
		english: 'English',
		simplified: '中文(简体)',
		traditional: '中文(繁體)'
	},
	footer: {
		columns: {
			company: 'Company',
			individual: 'Individuals',
			enterprise: 'Businesses',
			community: 'Community',
			buyCrypto: 'Buy Crypto',
			help: 'Help',
			legal: 'Legal'
		},
		company: {
			aboutUs: 'About us',
			team: 'Team',
			investorOverview: 'Investor Overview',
			joinUs: 'Careers',
			marketFocus: 'Insights',
			blog: 'OSL Blog',
			mediaCoverage: 'In the News',
			cryptoEncyclopedia: 'Crypto Bits',
			announcement: 'Announcement'
		},
		individual: {
			flashTrade: 'Flash Trade',
			privateClients: 'Private Clients',
			proTrade: 'Pro Trade',
			recurringBuy: 'Recurring Buy'
		},
		enterprise: {
			proTrade: 'Pro Trade',
			otc: 'OTC',
			custody: 'Custody',
			staking: 'Staking',
			wealthManagement: 'Wealth Management',
			rwa: 'RWA',
			omnibus: 'Omnibus',
			stablex: 'StableX',
			api: 'API'
		},
		community: {
			emailPrompt:
				'Enter your email address to receive information and updates from OSL and its parent company (OSL Group)',
			emailPlaceholder: 'Enter your email',
			emailConsent:
				'By entering your email, you acknowledge and agree that OSL collects and uses your personal data in accordance with the Privacy Policy.',
			downloadApp: 'Download App'
		},
		buyCrypto: {
			buyBitcoin: 'Buy Bitcoin',
			buyEthereum: 'Buy Ethereum',
			productDisclosure: 'Product Disclosure'
		},
		help: {
			supportCenter: 'Support Center',
			fees: 'Fees',
			contactUs: 'Contact Us'
		},
		legal: {
			terms: 'Terms & Conditions',
			riskDisclosure: 'Risk Disclosures',
			tokenRules: 'Token Admission and Removal Rules',
			tradingRules: 'Trading Rules',
			privacyPolicy: 'Privacy Policy'
		},
		copyright: {
			rights: '© OSL. All rights reserved.',
			disclaimer1:
				'This website refers to trading of digital assets, which may include digital securities and other complex financial products or instruments which may not be suitable for all investors.',
			disclaimer2:
				'This website is not a solicitation, invitation or offer to enter into any transactions in digital assets or financial instruments.'
		}
	},
	stock: {
		hkStockExchange: 'Hong Kong Stock Exchange',
		tips: 'Minimum 15 minutes delayed. Source: Finenter',
		hkt: 'HKT'
	}
};
